<template>
    <router-link
    class="project-card"
    :id="slug"
    tag="div"
    :to="{name: slug}">

        <div class="card-img"
        :style="{
            backgroundImage: `url(img/thumbs/${slug}.jpg)`,
        }"></div>

        <div class="card-bg"
        :style="{
            backgroundColor: color
        }"></div>

        <div class="card-tags">
            <div class="card-tag"
            v-for="tag in tags"
            :key="tag.id"
            :style="{
                backgroundColor: color,
                color: contrastColor
            }">
            {{tag}}</div>
        </div>

        <div class="card-info">
            <h3>{{title}}</h3>
            <p class="card-meta">{{client}} • {{year}}</p>
            <div v-if="featured" class="card-brief"><p>{{brief}}</p></div>
        </div>

        <svg class="circle-link" width="130" height="130" viewBox="0 0 132 132" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="65" cy="65" r="64.5" fill="white"/>
            <path d="M40 45.5H63M63 45.5L54.701 38M63 45.5L54.701 53" stroke-linecap="square" stroke-linejoin="round"/>
        </svg>

    </router-link>
</template>

<script>
import anime from 'animejs'

export default {
  props: ['title', 'year', 'client', 'slug', 'color', 'contrastColor', 'brief', 'tags', 'featured'],
  mounted () {
    var self = this

    function animateCard (scale, duration, elasticity, mainColor, bgColor, strokeColor, tagColor, strokeWidth, rotation, bgScale, cardScale) {
      anime.remove(`#${self.$props.slug}`)
      anime.remove(`#${self.$props.slug} .card-bg`)
      anime.remove(`#${self.$props.slug} svg`)
      anime.remove(`#${self.$props.slug} svg circle`)
      anime.remove(`#${self.$props.slug} svg path`)
      anime.remove(`#${self.$props.slug} .card-tags .card-tag`)

      // Whole Card
      anime({
        targets: `#${self.$props.slug}`,
        scale: cardScale,
        translateY: 0,
        duration: 1000,
        easing: 'easeOutCirc'
      })

      // BackgroundColor
      anime({
        targets: `#${self.$props.slug} .card-bg`,
        scaleY: bgScale,
        duration: 500,
        easing: 'easeOutCirc'
      })

      // Entire SVG Button
      anime({
        targets: `#${self.$props.slug} svg`,
        rotate: rotation,
        duration: duration
      })

      // Circle
      anime({
        targets: `#${self.$props.slug} svg circle`,
        fill: mainColor,
        scale: scale,
        duration: duration,
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        easing: 'easeOutCirc'
        // elasticity: elasticity
      })

      // Path
      anime({
        targets: `#${self.$props.slug} svg path`,
        fill: mainColor,
        scale: scale,
        duration: duration,
        stroke: strokeColor,
        strokeWidth: strokeWidth
        // rotate: rotation,
        // elasticity: elasticity
      })

      // Tags
      anime({
        targets: `#${self.$props.slug} .card-tags .card-tag`,
        color: tagColor,
        backgroundColor: bgColor,
        borderColor: mainColor,
        duration: duration,
        delay: anime.stagger(50)
      })
    }

    function enterButton () { animateCard(1.2, 800, 400, self.$props.color, '#FFFFFF', '#FFFFFF', self.$props.color, 4, -15, 1, 1.03) };
    function leaveButton () { animateCard(1.0, 600, 300, '#FFFFFF', self.$props.color, '#E4E7EB', self.$props.contrastColor, 2, 0, 0, 1) };

    document.querySelector(`#${this.$props.slug}`).addEventListener('mouseenter', enterButton, false)
    document.querySelector(`#${this.$props.slug}`).addEventListener('mouseleave', leaveButton, false)

    // animateCard(1.2, 1, 400, self.$props.color, '#FFFFFF', '#FFFFFF', self.$props.color, 4, -15, 1);
    // animateCard(1.0, 1, 300, '#FFFFFF', self.$props.color, '#E4E7EB', self.$props.contrastColor, 2, 0, 0)
  }
}
</script>

<style lang="scss">

$bgHeight: 150px;

.project-card {
    overflow: hidden;
    transition: box-shadow .75s ease-out;
    position: relative;
    @extend %linkify;

    .card-img {
        width: 100%;
        height: $bgHeight;
        background-size: cover;
        background-position: center;
        //box-shadow: inset $grid-gap-negative*.75 0 $white;
    }

    .card-bg {
        width: 100%;
        height: $bgHeight;
        mix-blend-mode: overlay;
        transform-origin: bottom;
        transform: scaleY(0);
        position: absolute;
        top: 0;
    }

    .card-info {
        padding: 1.5rem 1rem;

        h3 {
            font-family: $title-font;
            font-size: 1.25rem;
            color: $gray8;
            margin-bottom: .25rem;
        }

        .card-meta {
            font-size: .85rem;
            color: $gray4;
            text-transform: uppercase;
        }

    }

    .card-tags {
        margin: -.75rem 0 0 1rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;

        .card-tag {
            font-size: 0.75rem;
            padding: .25rem 1rem;
            border-radius: 1rem;
            margin-right: .5rem;
            letter-spacing: 0.05rem;
            border: 2px solid $white;
            text-transform: uppercase;
            z-index: 99;
            user-select: none;
            font-family: $display-font;
            //transition: all .25s ease-out;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }

    svg.circle-link {
        position: absolute;
        right: -40px;
        bottom: -40px;
        overflow: visible;

        circle, path {
            stroke: $gray2;
            stroke-width: 2px;
        }

    }

    &:hover {
        box-shadow: $elevated-shadow !important;
    }
}

.featured {
    grid-row: span 2;

    &:after {
     //   content: 'FEATURED';
        display: block;
    }

    .card-img {
        height: 50%;
    }

    .card-bg {
        height: 50%;
    }

    .card-info {

        h3 {
            font-size: 1.5rem;
        }

        .card-brief {
            border-top: 1px solid $gray2;
            margin-top: 15px;

            p {
                color: $gray4;
                padding-right: 24%;
                margin-top: 15px;
            }
        }

    }

}

</style>
